import firebase from "firebase/compat/app";
import { getApps, initializeApp } from "firebase/app";
import { browserSessionPersistence, getAuth, initializeAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let instance;

export default function getFirebase() {
  if (typeof window !== "undefined") {
    if (instance) return instance;

    instance = firebase.initializeApp(config);
    // window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

    initializeAppCheck(instance, {
      provider: new ReCaptchaV3Provider(
        process.env.REACT_APP_RECAPCHA
      ),

      // Optional argument. If true, the SDK automatically refreshes App Check
      // tokens as needed.
      isTokenAutoRefreshEnabled: true,
    });

    return instance;
  }

  return null;
}

// --- DB Interface session ---------------------------------------------------------------
// The DB Interface must ask for a fresh Google sign-in in every new tab, while the Printer
// dashboard keeps its long-lived session. Switching the default Auth to session persistence
// would MIGRATE the printer session into this tab's sessionStorage and sign /printer out
// everywhere else, so the DB Interface gets its own Firebase app + Auth instance instead:
// same project (identical tokens for the server), separate storage, per-tab persistence.
const DB_INTERFACE_APP_NAME = "dbInterfaceSession";
let dbInterfaceAuthInstance;

export function getDbInterfaceAuth() {
  if (typeof window === "undefined") return null;
  if (dbInterfaceAuthInstance) return dbInterfaceAuthInstance;

  const existingApp = getApps().find((app) => app.name === DB_INTERFACE_APP_NAME);
  const dbInterfaceApp = existingApp || initializeApp(config, DB_INTERFACE_APP_NAME);

  if (!existingApp) {
    try {
      initializeAppCheck(dbInterfaceApp, {
        provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPCHA),
        isTokenAutoRefreshEnabled: true,
      });
    } catch (e) {
      console.warn("[firebase] App Check init for the DB Interface app failed:", e?.message || e);
    }
  }

  try {
    dbInterfaceAuthInstance = initializeAuth(dbInterfaceApp, {
      persistence: browserSessionPersistence,
    });
  } catch (e) {
    // Already initialised for this app (hot reload): reuse it.
    dbInterfaceAuthInstance = getAuth(dbInterfaceApp);
  }
  return dbInterfaceAuthInstance;
}
